import itemReducer from '../../../items/item.reducers';
import {
  closeAdGroup,
  modifyAdGroup,
  receiveAdGroup,
  setAdGroupHasValidationError,
  setAdGroupIsBusy
} from './ad-group.actions';

const adGroupReducer = itemReducer(
  receiveAdGroup,
  setAdGroupIsBusy,
  modifyAdGroup,
  closeAdGroup,
  undefined,
  setAdGroupHasValidationError
);

export default adGroupReducer;
